var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 125,
    viewBox: "0 0 79 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M6.4269 58.3851C-2.09314 48.2313 -0.768724 33.0931 9.38507 24.5731L95.182 -47.4191C105.336 -55.9392 120.474 -54.6147 128.994 -44.4609L200.986 41.336C209.506 51.4898 208.182 66.6279 198.028 75.148L112.231 147.14C102.077 155.66 86.9392 154.336 78.4191 144.182L6.4269 58.3851Z",
    fill: "#EC8200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTriangle);
export default __webpack_public_path__ + "static/media/yellow-triangle.586a5da6373a9c419eb2d2b4964ec402.svg";
export { ForwardRef as ReactComponent };